//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'lodash.debounce'
import Float from '@/js/float'
export default {
  name: 'editAmountDialog',
  props: {
    value: Boolean,
    repayInitData: Object,
    isChooseGold: String,
    defaultAmount: String
  },
  created() {
    const { upAmount, vipVo, isdraw } = this.repayInitData
    this.maxAmount = upAmount
    this.inputAmount = this.defaultAmount
    if (vipVo && this.isChooseGold === 'y') {
      this.maxAmount = Float.add(this.maxAmount, vipVo.svipOutPrice, 2)
      this.inputAmount = Float.add(this.defaultAmount, vipVo.svipOutPrice, 2)
    }
  },
  watch: {
    inputAmount() {
      this.showClear = this.inputAmount > 0
    },
    show() {
      this.$emit('input', this.show)
    },
    value() {
      this.show = this.value
    }
  },
  data() {
    return {
      show: this.value,
      inputAmount: 0,
      errorTips: '',
      showClear: false
    }
  },
  methods: {
    clear() {
      this.inputAmount = ''
      this.$refs.input.focus()
    },
    focus() {
      if (this.inputAmount) {
        this.showClear = true
      }
    },
    blur() {
      setTimeout(() => {
        this.showClear = false
      }, 0)
    },
    onKeyup: debounce(function() {
      this.inputAmount = (this.inputAmount + '').replace(/([^\d\.])/g, '')
      if (/\d+(\.\d{2,})/.test(this.inputAmount)) {
        this.inputAmount =
          Math.floor(Float.multiply(this.inputAmount, 100)) / 100
      }
    }, 500),
    cancel() {
      this.errorTips = ''
      this.show = false
    },
    confirmRepayAmount() {
      const { minExpirePartAmount, vipVo } = this.repayInitData

      const isGoldChoosed = this.isChooseGold === 'y'
      const svipOutPrice = vipVo && vipVo.svipOutPrice

      const minAmount = isGoldChoosed
        ? Float.add(minExpirePartAmount, svipOutPrice, 2)
        : minExpirePartAmount

      if (!/^\d+(.\d+)?$/.test(this.inputAmount)) {
        this.errorTips = '还款金额必须为数字'
      } else if (+this.inputAmount > +this.maxAmount) {
        this.errorTips = `还款金额不能大于最大还款金额${this.maxAmount}`
      } else if (+this.inputAmount < +minAmount) {
        this.errorTips = `还款金额必须大于等于最小还款金额${minAmount}`
      } else {
        this.errorTips = ''
        this.show = false
        this.$emit(
          'confirm-amount',
          this.isChooseGold === 'y'
            ? Float.subtract(this.inputAmount, svipOutPrice, 2)
            : this.inputAmount
        )
      }
    }
  }
}
